import React from "react";
import { Link } from "react-router-dom";
require('../style/components/breadcrumb.scss');

const Breadcrumb = (props) => {
    return (
        <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
                {props.items.map((item, index) => 
                <li key={index} className={`breadcrumb-item ${item.active ? 'active' : ''}`}>
                    {item.active ? item.title : <Link to={item.route}>{item.title}</Link>}
                </li>) ?? <></>}
            </ol>
        </nav>
    )
}

export default Breadcrumb;